import { Component, ComponentChild, h } from 'preact';
import { Properties } from '../common';
import { isClient, isServer, values } from '../utils';
import { StyleContext, StyleRegistry, StyleSheet } from './types';

interface StyleState {
  styles: string;
}

// eslint-disable-next-line react/prefer-stateless-function
export class Style extends Component<Properties, StyleState> {
  private listenerId: number;
  private styles: string;

  constructor(props: Properties, context: StyleContext) {
    super(props);
    if (isServer()) {
      this.listenerId = this.getListener(context);
    }
  }

  componentDidMount(): void {
    if (isClient()) {
      this.listenerId = this.getListener(this.context);
    }
  }

  componentWillUnMount(): void {
    this.context.styles.removeListener(this.listenerId);
  }

  private getListener(context: StyleContext) {
    return context.styles?.addListener((styleRegistry: StyleRegistry) => {
      const styles: string = values(styleRegistry)
        .map((styleSheet: StyleSheet) => styleSheet.css)
        .reduce((acc: string, css: string) => acc + css, '');

      if (isServer()) {
        this.styles = styles;
      } else {
        this.setState(() => ({ styles }));
      }
    });
  }

  render(_: Properties, { styles }: StyleState): ComponentChild {
    // eslint-disable-next-line react/no-danger
    return <style type="text/css" dangerouslySetInnerHTML={{ __html: this.styles ?? styles }} />;
  }
}
